var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.resolutionStatusList && _vm.resolutionStatusList.length)?_c('Form',{ref:"caseDetailsForm",attrs:{"form-data":_vm.formData,"default-values":_vm.defaultValues},on:{"onChange":_vm.updateOnChange,"updateOnSearch":_vm.updateOnSearch,"onSubmitForm":_vm.onSubmitForm,"onOpenDropdown":function($event){return _vm.onOpenDropdown()}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }